/**
 * @file scripts/components/user/session.js
 * @description
 */
import cookies from './cookies';

const session = {
    isAuthenticated: () => {
        let auth = false;
        if (sessionStorage) {
            if (sessionStorage.getItem('fft_minisite_username') != null) {
                auth = true;
            }
        } else {
            console.log('sessionStorage not supported');
        }
        return auth;
    },

    getUserName: () => {
        let user = undefined;
        if (sessionStorage) {
            user = sessionStorage.getItem('fft_minisite_username');
        } else {
            console.log('sessionStorage not supported');
        }
        return user;
    },

    getToken: () => {
        let token = undefined;
        if (sessionStorage) {
            token = sessionStorage.getItem('fft_minisite_token');
        } else {
            console.log('sessionStorage not supported');
        }
        return token;
    },

    getVersion: () => {
        let version = undefined;
        if (sessionStorage) {
            version = sessionStorage.getItem('fft_minisite_version');
        } else {
            console.log('sessionStorage not supported');
        }
        return version;
    },

    setToken: (token) => {
        if (sessionStorage) {
            sessionStorage.setItem('fft_minisite_token', token);
        } else {
            console.log('sessionStorage not supported');
        }            
    },

    //
    // A public method for "starting" a session with the given token. We
    // update our instal stores and cookie the token.
    //
    start: (token, username, version=null) => {
        if (sessionStorage) {
            sessionStorage.setItem('fft_minisite_username', username);
            sessionStorage.setItem('fft_minisite_token', token);
            if (version) {
                sessionStorage.setItem('fft_minisite_version', version);
            }
        } else {
            console.log('sessionStorage not supported');
        }            
    },

    //
    // A public method for "ending" as session. We destroy our token in
    // both our internal cache and from the cookie.
    //
    end: () => {
        if (sessionStorage) {
            sessionStorage.removeItem('fft_minisite_username');
            sessionStorage.removeItem('fft_minisite_token');
            sessionStorage.removeItem('fft_minisite_version');
        } else {
            console.log('sessionStorage not supported');
        } 
    }
};

export default session